<div class="top-buttons-row">
  <button mat-raised-button (click)="cancel()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="dialog-content">
  <h1 mat-dialog-title>{{'components.createissuedialog.titlecreateuserstory' | translate}}</h1>
  <div class="value-field-horizontal">
    <p class="sprintdialog-label">{{'components.createissuedialog.name' | translate}}</p>
    <mat-form-field>
      <input matInput [formControl]="UsNameFormControl" [(ngModel)]="data.name">
      <mat-error *ngIf="UsNameFormControl.hasError('required')">
        Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="value-field-horizontal">
    <p class="sprintdialog-label">{{'components.createissuedialog.description' | translate}}</p>
    <mat-form-field>
      <input matInput [(ngModel)]="data.description">
    </mat-form-field>
  </div>
  <div class="bottom-buttons">
    <button mat-raised-button  [disabled]="!data.name"
            [mat-dialog-close]="data">{{'components.createissuedialog.create' | translate}}
    </button>
  </div>
</div>
